<template>
  <main>
    <banner :title="getText('private-title')"/>

    <section class="bg-gray-700">
      <div class="container mx-auto px-4 pb-16 md:pb-48">
        <div class="flex flex-wrap w-full">
          <div class="pt-12 w-full">
            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('saules-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('saules-address') }}</h3>
                </div>

                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">
                    {{ getText('development-and-building-time') }}: {{ getText('saules-development-time') }}
                  </p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="group in group7" :key="group" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(group) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-description') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-ground-area') }}: 1 154 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-construction-area') }}: 57,1 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-area') }}: 59,9 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('floor-count') }}: 2</span>
                      </li>
                    </ul>
                  </div>
                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('saules-description-1') }}</p>
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('saules-description-2') }}</p>
                  </div>

                  <div class="text-white pt-4">
                    <p class="font-semibold underline">{{ getText('building-status-1') }}</p>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesSaules"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('libiesi-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('libiesi-address') }}</h3>
                </div>
                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">
                    {{ getText('development-time') }}: {{ getText('libiesi-time') }}
                  </p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('mencu-group-1') }}</p>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-description') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-ground-area') }}: 2 013 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-construction-area') }}: 302,5 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-area') }}: 455,7 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('floor-count') }}: 2</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-volume') }}: 2 596 m³</span>
                      </li>
                    </ul>
                  </div>
                  <div class="text-white pt-4">
                    <p class="font-semibold underline">{{ getText('libiesi-detail') }}</p>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="imgLibiesu"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('mencu-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('mencu-address') }}</h3>
                </div>
                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">
                    {{ getText('development-and-building-time') }}: {{ getText('mencu-development-time') }}
                  </p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="group in group8" :key="group" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(group) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-description') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('living-building') }}</span>
                      </li>
                      <li class="pl-16">
                        <span>{{ getText('object-total-ground-area') }}: 1 736 m²</span>
                      </li>
                      <li class="pl-16">
                        <span>{{ getText('object-construction-area') }}: 223,9 m²</span>
                      </li>
                      <li class="pl-16">
                        <span>{{ getText('object-total-area') }}: 180,9 m²</span>
                      </li>
                      <li class="pl-16">
                        <span>{{ getText('floor-count') }}: 2</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4 pt-4"></i>
                        <span>{{ getText('maintenance-building') }}</span>
                      </li>
                      <li class="pl-16">
                        <ul>
                          <li>
                            <span>{{ getText('object-construction-area') }}: 108,7 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('object-total-area') }}: 80,8 m²</span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div class="text-white pt-4">
                    <p class="font-semibold underline">{{ getText('mencu-detail') }}</p>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="imgMencu"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('bulduru-title') }}</h2>
                </div>
                <div class="block">
                  <p class="text-white font-semibold mb-4 pr-16">{{ getText('bulduru-duties') }}: Mārcis Mežulis</p>

                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2019. - 2020.</p>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('object-data') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('apartemenent-area') }}: 227 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('terace-area') }}: 78 m²</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesBulduru"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('private-location-1') }}</h2>
                </div>
                <div class="block">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}:
                    {{ getText('private-1-time') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('object-building') }}: {{
                      getText('year-2015')
                    }} </p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="partner in partners1" :key="partner" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(partner) }}</span>
                      </li>
                    </ul>
                  </div>

                  <p class="text-white font-semibold mt-4">{{ getText('contractor') }}: “Dores” </p>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('object-data') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-parcel-area') }}: 913 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-construction-area') }}: 217.1 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('level-area') }}: 292.0 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('floor-count') }}: 2</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white pt-4">
                    <p class="font-semibold underline">{{ getText('building-status-1') }}</p>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesDarza"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('private-location-2') }}</h2>
                </div>
                <div class="block">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}:
                    {{ getText('private-2-time') }}</p>

                  <div class="text-white font-semibold">
                    <p class="pb-4">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="partner in partners2" :key="partner" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(partner) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('object-data') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-parcel-area') }}: 1,904 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-construction-area') }}: 240.2 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('level-area') }}: 235.8 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('floor-count') }}: 1</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white py-4">
                    <p class="font-semibold underline">{{ getText('building-status-2') }}</p>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slides52B"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('private-location-3') }}</h2>
                </div>
                <div class="block">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}:
                    {{ getText('private-3-time') }}</p>

                  <div class="text-white font-semibold">
                    <p class="pb-4">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="partner in partners3" :key="partner" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(partner) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('object-data') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-parcel-area') }}: 1,904 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-construction-area') }}: 211.0 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('level-area') }}: 290.2 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('floor-count') }}: 2</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="text-white py-4">
                  <p class="font-semibold underline">{{ getText('building-status-2') }}</p>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slides52A"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('samara-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('samara-address') }}</h3>
                </div>
                <div class="block">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2009</p>

                  <p class="text-white font-semibold mb-4">{{ getText('samara-authors') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('samara-subtitle') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('samara-desc-1') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('samara-desc-2') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('samara-desc-3') }}</p>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesSamara"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('gertrudes-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('gertrudes-address') }}</h3>
                </div>
                <div class="block">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2004</p>

                  <div class="text-white font-semibold">
                    <p class="pb-4">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="partner in partners4" :key="partner" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(partner) }}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="text-white font-semibold">
                  <p class="text-white font-semibold mb-4 mt-4">{{ getText('object-data') }}</p>
                  <ul>
                    <li>
                      <i class="fas fa-caret-up pr-4 pl-4"></i>
                      <span>{{ getText('object-parcel-area') }}: 2,622 m²</span>
                    </li>
                    <li>
                      <i class="fas fa-caret-up pr-4 pl-4"></i>
                      <span>{{ getText('object-construction-area') }}: 237 m²</span>
                    </li>
                    <li>
                      <i class="fas fa-caret-up pr-4 pl-4"></i>
                      <span>{{ getText('object-total-area') }}: 450 m³</span>
                    </li>
                    <li>
                      <i class="fas fa-caret-up pr-4 pl-4"></i>
                      <span>{{ getText('floor-count') }}: 2</span>
                    </li>
                  </ul>
                </div>
                <div class="text-white py-4">
                  <p class="font-semibold underline">{{ getText('gertrudes-comment') }}</p>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesGertrudes"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('mildas15-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('mildas15-address') }}</h3>
                </div>
                <div class="block">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2005</p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="group in group5" :key="group" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(group) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-data') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-ground-area') }}: 1 433 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('pavement-area') }}: 106 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('living-building') }}</span>
                      </li>
                      <li class="pl-16">
                        <ul>
                          <li>
                            <span>{{ getText('object-construction-area') }}: 249 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('object-total-area') }}: 207 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('floor-count') }}: 1</span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('maintenance-building') }}</span>
                      </li>
                      <li class="pl-16">
                        <ul>
                          <li>
                            <span>{{ getText('object-construction-area') }}: 48 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('object-total-area') }}: 34 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('floor-count') }}: 1</span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="text-white py-4">
                  <p class="font-semibold underline">{{ getText('diklu-comment') }}</p>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesMildas15"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('langstini–title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('langstini–address') }}</h3>
                </div>
                <div class="block">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2005</p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="group in group4" :key="group" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(group) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-data') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-ground-area') }}: 1 687 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-construction-area') }}: 322 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-area') }}: 270 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('floor-count') }}: 1</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="text-white py-4">
                  <p class="font-semibold underline">{{ getText('langstini–comment') }}</p>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesMildas3"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('diklu-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('diklu-address') }}</h3>
                </div>
                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2005</p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="group in group3" :key="group" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(group) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-data') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-ground-area') }}: 1 753 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('pavement-area') }}: 252 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('living-building') }}</span>
                      </li>
                      <li class="pl-16">
                        <ul>
                          <li>
                            <span>{{ getText('object-construction-area') }}: 226 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('object-total-area') }}: 253.1 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('object-volume') }}: 1 304 m³</span>
                          </li>
                          <li>
                            <span>{{ getText('floor-count') }}: 2</span>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('maintenance-building') }}</span>
                      </li>
                      <li class="pl-16">
                        <ul>
                          <li>
                            <span>{{ getText('object-construction-area') }}: 99 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('object-total-area') }}: 38.6 m²</span>
                          </li>
                          <li>
                            <span>{{ getText('object-volume') }}: 268 m³</span>
                          </li>
                          <li>
                            <span>{{ getText('floor-count') }}: 1</span>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="text-white py-4">
                  <p class="font-semibold underline">{{ getText('diklu-comment') }}</p>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesDiklu"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('private-lattelecom-1') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('private-lattelecom-address') }}</h3>
                </div>
                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-lattelecom-customer') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2005</p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="group in group1" :key="group" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(group) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-description') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('private-lattelecom-area-1') }}: 1 141.5 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('private-lattelecom-area-2') }}: 3 900 m³</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('project-parts') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('private-lattelecom-part-1') }}</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('private-lattelecom-part-2') }}</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('private-lattelecom-part-3') }}</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('private-lattelecom-part-4') }}</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('private-lattelecom-part-5') }}</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('private-lattelecom-part-6') }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesLattelecom"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('angel-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('angel-address') }}</h3>
                </div>
                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-time') }}: 2001</p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="group in group2" :key="group" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(group) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-description') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-ground-area') }}: 1 563 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-construction-area') }}: 195.6 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('useful-area') }}: 160.2 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('floor-count') }}: 1</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="text-white py-4">
                  <p class="font-semibold underline">{{ getText('angel-comment') }}</p>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesAngel"></slider>
              </div>
            </div>

            <div class="flex flex-wrap w-full pb-24">
              <div class="w-full md:w-6/12">
                <div class="block mb-4">
                  <h2 class="text-white font-semibold text-3xl">{{ getText('konkordijas-title') }}</h2>
                  <h3 class="text-white font-semibold text-xl">{{ getText('konkordijas-address') }}</h3>
                </div>
                <div class="block mb-4">
                  <p class="text-white font-semibold mb-4">{{ getText('client') }}:
                    {{ getText('private-1-2-3-client') }}</p>

                  <p class="text-white font-semibold mb-4">{{ getText('development-and-building-time') }}: 1996 -
                    2000</p>

                  <div class="text-white font-semibold">
                    <p class="pb-2">{{ getText('project-group') }}:</p>
                    <ul>
                      <li v-for="group in group6" :key="group" class="flex">
                        <i class="fas fa-caret-up pr-4 pl-4 pt-3 block"></i>
                        <span class="pt-2">{{ getText(group) }}</span>
                      </li>
                    </ul>
                  </div>

                  <div class="text-white font-semibold">
                    <p class="text-white font-semibold mb-4 mt-4">{{ getText('building-description') }}</p>
                    <ul>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-ground-area') }}: 1 353 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-construction-area') }}: 187 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('object-total-area') }}: 315 m²</span>
                      </li>
                      <li>
                        <i class="fas fa-caret-up pr-4 pl-4"></i>
                        <span>{{ getText('floor-count') }}: 2</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="w-full md:w-6/12 md:pl-16 pt-4 md:pt-0">
                <slider :images="slidesKonkordija"></slider>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import * as partners from '../../data/projectPartners'
import * as imagesSources from '../../data/projectImages'
import {mapGetters} from "vuex";
import Slider from '../../components/Slider.vue';
import Banner from "../Banner";

export default {
  name: "Private",
  data: function () {
    return {
      partners1: partners.PRIVATE_PARTNER_1,
      partners2: partners.PRIVATE_PARTNER_2,
      partners3: partners.PRIVATE_PARTNER_3,
      partners4: partners.PRIVATE_PARTNER_4,
      group1: partners.PRIVATE_GROUP_1,
      group2: partners.PRIVATE_GROUP_2,
      group3: partners.PRIVATE_GROUP_3,
      group4: partners.PRIVATE_GROUP_4,
      group5: partners.PRIVATE_GROUP_5,
      group6: partners.PRIVATE_GROUP_6,
      group7: partners.PRIVATE_GROUP_7,
      group8: partners.PRIVATE_GROUP_8,
      slides52B: imagesSources.IMG_52B,
      slides52A: imagesSources.IMG_52A,
      slidesDarza: imagesSources.DARZA,
      slidesBulduru: imagesSources.BULDURU,
      slidesSamara: imagesSources.SAMARA,
      slidesGertrudes: imagesSources.GERTRUDES,
      slidesMildas15: imagesSources.MILDAS_15,
      slidesMildas3: imagesSources.MILDAS_3,
      slidesDiklu: imagesSources.DIKLU,
      slidesLattelecom: imagesSources.LATTELECOM,
      slidesAngel: imagesSources.ANGEL,
      slidesKonkordija: imagesSources.KONKORDIJA,
      slidesSaules: imagesSources.SAULES,
      imgMencu: imagesSources.MENCU,
      imgLibiesu: imagesSources.LIBIESU,
    }
  },
  computed: {
    ...mapGetters(['getText'])
  },
  components: {
    Banner,
    Slider,
  },
}
</script>